import { useEffect, useRef, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FiCheckCircle, FiXCircle, FiLoader, FiShield } from 'react-icons/fi';
import { checkPersonEmailVerificationToken, confirmPersonEmailVerification } from '../../services/api';
import styles from './PersonEmailVerification.module.css';

const PersonEmailVerification = () => {
  const { token } = useParams();
  const [status, setStatus] = useState('loading'); // loading | confirm | confirming | success | error
  const checked = useRef(false);

  useEffect(() => {
    if (!token || checked.current) return;
    checked.current = true;
    checkPersonEmailVerificationToken(token)
      .then((res) => setStatus(res.data.valid ? 'confirm' : 'error'))
      .catch(() => setStatus('error'));
  }, [token]);

  const handleConfirm = () => {
    setStatus('confirming');
    confirmPersonEmailVerification(token)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        {status === 'loading' && (
          <>
            <FiLoader className={styles.iconSpin} size={48} />
            <h2 className={styles.title}>Checking your link…</h2>
          </>
        )}

        {status === 'confirm' && (
          <>
            <FiShield size={48} />
            <h2 className={styles.title}>Confirm this contact email</h2>
            <p className={styles.desc}>Click below to verify this email address.</p>
            <button className={styles.btn} onClick={handleConfirm}>Verify email</button>
          </>
        )}

        {status === 'confirming' && (
          <>
            <FiLoader className={styles.iconSpin} size={48} />
            <h2 className={styles.title}>Verifying…</h2>
          </>
        )}

        {status === 'success' && (
          <>
            <FiCheckCircle className={styles.iconSuccess} size={48} />
            <h2 className={styles.title}>Email verified!</h2>
            <p className={styles.desc}>This contact email has been successfully verified.</p>
            <Link to="/" className={styles.btn}>Go to Home</Link>
          </>
        )}

        {status === 'error' && (
          <>
            <FiXCircle className={styles.iconError} size={48} />
            <h2 className={styles.title}>Verification failed</h2>
            <p className={styles.desc}>This verification link is invalid or has expired (links expire after 24 hours).</p>
            <Link to="/" className={styles.linkBack}>← Back to Home</Link>
          </>
        )}
      </div>
    </div>
  );
};

export default PersonEmailVerification;
